import "bootstrap/dist/css/bootstrap.min.css";
import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import "animate.css";
import "./style.css";
import "./i18n";

// Main Layout
const App = lazy(() => import("./App.jsx"));

// Lazy-loaded Components
const Home = lazy(() => import("./Components/Home.jsx"));
const About_us = lazy(() => import("./Components/About_us.jsx"));
const Account = lazy(() => import("./Components/Account.jsx"));
const Commodities = lazy(() => import("./Components/Commodities.jsx"));
const Crypto = lazy(() => import("./Components/Crypto.jsx"));
const Contact_us = lazy(() => import("./Components/Contact_us.jsx"));
const Faq = lazy(() => import("./Components/Faq.jsx"));
const Forex = lazy(() => import("./Components/Forex.jsx"));
const Indices = lazy(() => import("./Components/Indices.jsx"));
const Legal = lazy(() => import("./Components/Legal.jsx"));
const Stock = lazy(() => import("./Components/Stock.jsx"));
const NotFound = lazy(() => import("./Components/NotFound.jsx"));
const Products = lazy(() => import("./Components/Products.jsx"));
const Acceptable_Use_Policy = lazy(() =>
  import("./Components/Acceptable_Use_Policy.jsx")
);
const Refund_Return_Policy = lazy(() =>
  import("./Components/Refund_Return_Policy.jsx")
);
const Risk_Disclosure_Policy = lazy(() =>
  import("./Components/Risk_Disclosure_Policy.jsx")
);
const Privacy_Policy = lazy(() => import("./Components/Privacy_Policy.jsx"));
const KYC_Policy = lazy(() => import("./Components/KYC_Policy.jsx"));
const Terms_Conditions = lazy(() =>
  import("./Components/Terms_Conditions.jsx")
);
const AML_Policy = lazy(() =>
  import("./Components/AML_Policy.jsx")
);
const Deposits_Withdrawals = lazy(() =>
  import("./Components/Deposits_Withdrawals.jsx")
);
// Create Router
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={<div className="text-center py-5">Loading...</div>}>
        <App />
      </Suspense>
    ),
    children: [
      { path: "/", element: <Home /> },
      { path: "/about", element: <About_us /> },
      { path: "/contact", element: <Contact_us /> },
      { path: "/forex", element: <Forex /> },
      { path: "/commodities", element: <Commodities /> },
      { path: "/crypto", element: <Crypto /> },
      { path: "/stock", element: <Stock /> },
      { path: "/indices", element: <Indices /> },
      { path: "/faq", element: <Faq /> },
      { path: "/legal", element: <Legal /> },
      { path: "/account", element: <Account /> },
      { path: "/products", element: <Products /> },
      { path: "/acceptable-use-policy", element: <Acceptable_Use_Policy /> },
      { path: "/refund-return-policy", element: <Refund_Return_Policy /> },
      { path: "/risk-disclosure-policy", element: <Risk_Disclosure_Policy /> },
      { path: "/privacy-policy", element: <Privacy_Policy /> },
      { path: "/kyc-policy", element: <KYC_Policy /> },
      { path: "/terms-conditions", element: <Terms_Conditions /> },
      { path: "/aml-policy", element: <AML_Policy />},
      { path: "/deposits-withdrawals", element: <Deposits_Withdrawals /> },
      { path: "*", element: <NotFound /> },
    ],
  },
]);

// Render App
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <Suspense fallback={<div className="text-center py-5">Loading App...</div>}>
      <RouterProvider router={router} />
    </Suspense>
  </React.StrictMode>
);
